import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class RadioGroup extends Component {
  getChildContext () {
    const {name, selectedValue, onChange} = this.props
    return {
      radioGroup: {
        name, selectedValue, onChange
      }
    }
  }

  render () {
    const { Component, name, selectedValue, onChange, children, ...rest } = this.props
    return <Component {...rest}>{children}</Component>
  }
}

const { string, number, bool, func, oneOfType, node, object } = PropTypes
RadioGroup.propTypes = {
  name: string,
  selectedValue: oneOfType([
    string,
    number,
    bool
  ]),
  onChange: func,
  children: node.isRequired,
  Component: oneOfType([
    string,
    func,
    object
  ])
}

RadioGroup.defaultProps = {
  Component: 'div'
}

RadioGroup.childContextTypes = {
  radioGroup: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/RadioGroup.js